<template>
  <div >
    <app-to-top />
    <head-nav />
    <router-view  :plates="plates" v-if="plates.length>0" :key="Math.random()"></router-view>
    <footer-nav />
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import global from "../components/PublicComs/Common.vue";
import HeadNav from "../components/PublicComs/HeadNav.vue";
import FooterNav from "../components/HomeComs/FooterNav.vue";
import HeadNavM from "../components/PublicComs/HeadNav_M.vue";
 import AppToTop from "../components/PublicComs/AppToTop.vue";
export default {
  data() {
    return {
      timer: "",
      global,
      webdata: {},
      plates: [],
    };
  },

  components: { HeadNav, FooterNav, AppToTop,HeadNavM },

  computed: {},
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created(){
     
  },
  beforeMount(){
//     if(localStorage.onlymycourseWrd=="1")
//       this.$root.onlymycourse = true;
//     else 
//     this.$root.onlymycourse = false;
//      this.$root.hasCourse =localStorage.hasCourseWrd.split(",");
// this.$axios.get("/api/auth/me").then(res => {
//          let arrhasCourse = [];
//           for (var i = 0; i <res.data.data.needexaminee.length; i++)
//           {
//             arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
//           }
//           this.$root.hasCourse =arrhasCourse;
//          this.$root.ischeckface = res.data.data.ischeckface;
//          this.$root.onlymycourse = res.data.data.onlymycourse;
//                   this.$root.buytype = res.data.data.buytype;
          
//       })
  },
  mounted() {
    this.$axios
      .get("/api/categorys?page=1&limit=30&firstView=1")
      .then((res) => {
        if (res.data) {
          this.$nextTick(function() {
            this.plates = res.data.data;
          });
        }
      });
  },

  methods: {},
};
</script>
<style scoped>
.container{
  width: 1200px;
  max-width: 1200px;
}
</style>
